/**
 * When add/remove from favourites update also popups in map and _info variable of marker.
 */
(function ($) {
    $.nette.ext('offer-search-favourites', {
        init() {
            this.ext('snippets', true).after($.proxy(($el) => {
                const map = Bingo.Map.getInstance('offer-search-map');
                if (!$el.hasClass('js-btnFavourite') || $el.data('offer-id') === undefined || map === undefined) {
                    return;
                }

                const offerId = $el.data('offer-id');
                const name = $el.attr('data-name');
                const html = $el.html();
                const marker = map.markers[offerId];
                if (!marker) {
                    return;
                }
                const $info = $(marker._info);

                $(`[data-name="${name}"]`).html(html);

                const $favourite = $info.find(`[data-name="${name}"]`);
                $favourite.html(html);

                if (typeof map.markersInfos !== 'undefined' && typeof map.markersInfos[offerId] !== 'undefined') {
                    map.markersInfos[offerId][''] = $info.prop('outerHTML');
                }
                marker._info = $info.prop('outerHTML');
            }, this));
        },
    });

    $('.js-showMap-list').click(() => {
        const map = Bingo.Map.getInstance('offer-search-map');
        map.disableMap();
        this.blur();
    });

    $('.js-showMap-map').click(() => {
        const map = Bingo.Map.getInstance('offer-search-map');
        map.enableMap();
        this.blur();
    });
}(jQuery));
